import { useState } from "react";
import { observer } from "mobx-react-lite";
import { unstable_setTextOverflow } from "polotno/config";


const TextAutoFitToggle = observer(({ store }) => {

  const [autoFitTextEnabled, setAutoFitTextEnabled] = useState(() => {
    const saved = localStorage.getItem("teedex-auto-fit-text");
    return saved === "true";
});
  const selectedText = store.selectedElements[0];

  if (!selectedText || selectedText.type !== "text" || selectedText.curveEnabled) {
      return null;
  }

  const isActive = autoFitTextEnabled;

  const handleToggle = () => {
      const newValue = !isActive;

      setAutoFitTextEnabled(newValue);

      localStorage.setItem("teedex-auto-fit-text", newValue.toString());

      if (newValue) {
          unstable_setTextOverflow("change-font-size");
      } else {
          unstable_setTextOverflow("resize");
      }
  };

  return (
      <button
          className="bp5-button bp5-minimal"
          style={{
              color: isActive ? "#2A1FB3" : "black",
              backgroundColor: isActive ? "#E4E2FF" : "white",
              borderRadius: "4px",
              fontSize: ".729vw",
              fontWeight: "500",
              padding: "4px 8px",
          }}
          onClick={handleToggle}
          title="Auto-Fit Text: Scale font size to fit box"
      >
          {isActive ? "Auto-Fit ON" : "Auto-Fit OFF"}
      </button>
  );
});


export default TextAutoFitToggle;